
import RewardTable from './RewardTable.vue';

export default {
  i18nComponentKey: 'ReviewsNew.components.RewardDialog',
  name: 'RewardDialog',
  components: {
    RewardTable
  },
  props: {
    title: { type: String, required: true },
    rows: { type: Array, required: true },
    tableCaption: { type: String, default: null },
    missingRequiredFields: { type: Array, default: () => [] }
  },
  data() {
    return { maxHeight: 0 };
  },
  mounted() {
    const dialogHeight = document.querySelector('.AppBottomSheet__modal')
      .offsetHeight;
    this.maxHeight = `${(dialogHeight * 2) / 3}px`;
  }
};
